import { render } from "./CoolerWidget.vue?vue&type=template&id=07e3d39c&scoped=true"
import script from "./CoolerWidget.vue?vue&type=script&lang=js"
export * from "./CoolerWidget.vue?vue&type=script&lang=js"

import "./CoolerWidget.vue?vue&type=style&index=0&id=07e3d39c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-07e3d39c"

export default script